import _StudentUnitQuizResult from './model';
import * as _actions from './actions';
import _reducer from './reducer';

export const StudentUnitQuizResult = _StudentUnitQuizResult;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/UnitQuiz/index.js